import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import "./userDetailsTable.css";
import { FaPencilAlt } from "react-icons/fa";
import Toggle from "../toogle/toogle";

const UserDetailsTable = ({
  userdetails,
  dept,
  approval1,
  approval2,
  selectedcompany,
  getuserdetails,
}) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingApproval1, setIsEditingApproval1] = useState(false);
  const [isEditingApproval2, setIsEditingApproval2] = useState(false);
  const [isEditingRole, setIsEditingRole] = useState(false);
  const [isEditingDept, setIsEditingDept] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [modify, setmodify] = useState({
    newname: "",
    newrole: "",
    newdept: "",
    newapproval1: "",
    newapproval2: "",
    newcontact: "",
    newemail: "",
    newpassword: "",
    isActive: selectedUser?.status === 1 ? true : false,
  });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handlemodify = async () => {
    if (
      modify.newname &&
      modify.newrole &&
      modify.newdept &&
      modify.newcontact &&
      modify.newemail &&
      modify.newpassword &&
      userdetails?.status === (modify.isActive ? "Active" : "Inactive")
    ) {
      alert("Please fill anyone of the fields");
      return;
    }
    {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyuser.php`;
      const formData = new FormData();

      formData.append("user_id", selectedUser.user_id);
      formData.append("user_name", modify?.newname || selectedUser.user_name);
      formData.append("email", modify?.newemail || selectedUser.email);
      formData.append("phone_no", modify?.newcontact || selectedUser.phone_no);
      formData.append("password", modify?.newpassword || "");
      formData.append("role", modify?.newrole || selectedUser.role);
      formData.append("dept", modify?.newdept || selectedUser.dept);
      formData.append(
        "approval1",
        modify?.newapproval1 || selectedUser.approval1
      );
      formData.append(
        "approval2",
        modify?.newapproval2 || selectedUser.approval2
      );
      formData.append("status", modify.isActive ? 1 : 0);

      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setmodify({
            newname: "",
            newrole: "",
            newapproval1: "",
            newapproval2: "",
            newdept: "",
            newemail: "",
            newcontact: "",
            newpassword: "",
          });
          setSelectedUser(null);
          alert(data.message);
          getuserdetails();
        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    }
  };

  useEffect(() => {
    if (selectedUser) {
      setmodify((prev) => ({
        ...prev,
        isActive: String(selectedUser.status) === "1",
      }));
    }
  }, [selectedUser]);

  // console.log(userdetails)

  const roleMap = {
    user: "User",
    cmanager: "Manager",
    bh: "Business Head",
  };

  return (
    <div className="admin-portal-user-details-wrapper">
      <div className="admin-portal-user-table">
        <p className="company-info">
          Client Name:&nbsp;<strong>{selectedcompany}</strong>
        </p>

        {/* <h3>User Details</h3> */}
        {Array.isArray(userdetails) && userdetails.length > 0 ? (
          <table className="user-table">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Name</th>
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userdetails.map((item, index) => (
                <tr key={item.id || index} className="user-row">
                  <td>{index + 1}</td>
                  <td>{item.user_name}</td>
                  <td>{roleMap[item.role] || item.role}</td>
                  <td>
                    <button
                      onClick={() => {
                        setSelectedUser({
                          user_name: item.user_name,
                          email: item.email,
                          phone_no: item.phone_no,
                          role: item.role,
                          dept: item.department,
                          user_id: item.user_id,
                          id: item.id,
                          status: item.status,
                          approval1: item.approval1,
                          approval2: item.approval2,
                        });
                        setIsEditingName(false);
                        setIsEditingRole(false);
                        setIsEditingDept(false);
                        setIsEditingEmail(false);
                        setIsEditingContact(false);
                        setIsEditingPassword(false);
                        setIsEditingApproval1(false);
                        setIsEditingApproval2(false);
                      }}
                      className="sebtn"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No users available.</p>
        )}
      </div>

      {/* Side Popup Panel */}
      <AnimatePresence>
        {selectedUser && (
          <motion.div
            initial={{ x: "150%" }}
            animate={{ x: 0 }}
            exit={{ x: "150%" }}
            transition={{ type: "spring", stiffness: 80 }}
            className="user-detail-popup"
          >
            <button
              className="close-popup"
              onClick={() => setSelectedUser(null)}
            >
              &times;
            </button>
            <h4 className="userh4">User Info</h4>

            <div className="user-info-section">
              {/* userid */}
              <p>
                <strong>User ID:</strong> {selectedUser.user_id}{" "}
              </p>

              {/* Role */}
              {["admin", "bh"].includes(userDetails?.role) ? (
                !isEditingRole ? (
                  <p>
                    <strong>Role:</strong>{" "}
                    {roleMap[selectedUser.role] || selectedUser.role}
                    <button onClick={() => setIsEditingRole(true)}>
                      <FaPencilAlt />
                    </button>
                  </p>
                ) : (
                  <div className="input-block">
                    <label>
                      <strong>Role:</strong>
                    </label>
                    <select
                      className="admin-portal-select"
                      value={modify?.newrole || ""}
                      onChange={(e) =>
                        setmodify((prev) => ({
                          ...prev,
                          newrole: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select role
                      </option>
                      {selectedUser?.role === "cmanager" ||
                      selectedUser?.role === "user" ? (
                        <>
                          <option value="cmanager">Client Manager</option>
                          <option value="user">User</option>
                        </>
                      ) : (
                        <>
                          <option value="imanager">Support Manager</option>
                          <option value="icoordinator">
                            Support Coordinator
                          </option>
                        </>
                      )}
                    </select>

                    <button onClick={() => setIsEditingRole(false)}>
                      &times;
                    </button>
                  </div>
                )
              ) : (
                <p>
                  <strong>Role:</strong>
                  {roleMap[selectedUser.role] || selectedUser.role}
                </p>
              )}

              {/* Dept */}
              {["admin", "bh"].includes(userDetails?.role) ? (
                !isEditingDept ? (
                  <p>
                    <strong>Department:</strong> {selectedUser.dept}
                    <button onClick={() => setIsEditingDept(true)}>
                      <FaPencilAlt />
                    </button>
                  </p>
                ) : (
                  <div className="input-block">
                    <label>
                      <strong>Department:</strong>
                    </label>
                    <select
                      className="admin-portal-select"
                      value={modify?.newdept || ""}
                      onChange={(e) =>
                        setmodify((prev) => ({
                          ...prev,
                          newdept: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select Department
                      </option>

                      {dept?.map((dept, index) => (
                        <option key={index} value={dept?.dept}>
                          {dept?.dept}
                        </option>
                      ))}
                    </select>

                    <button onClick={() => setIsEditingDept(false)}>
                      &times;
                    </button>
                  </div>
                )
              ) : (
                <p>
                  <strong>Department:</strong>
                  {selectedUser.dept}
                </p>
              )}

              {/* Name */}
              {!isEditingName ? (
                <p>
                  <strong>Name:</strong> {selectedUser.user_name}
                  <button onClick={() => setIsEditingName(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Name:</strong>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    value={modify?.newname || ""}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newname: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingName(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Email */}
              {!isEditingEmail ? (
                <p>
                  <strong>Email:</strong> {selectedUser.email}{" "}
                  <button onClick={() => setIsEditingEmail(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Email:</strong>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter email"
                    value={modify?.newemail}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newemail: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingEmail(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Contact */}
              {!isEditingContact ? (
                <p>
                  <strong>Contact:</strong> {selectedUser.phone_no}{" "}
                  <button onClick={() => setIsEditingContact(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Contact:</strong>
                  </label>
                  <input
                    type="tel"
                    pattern="[0-9]{10}"
                    placeholder="Enter contact number"
                    value={modify?.newcontact}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newcontact: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingContact(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Password */}
              {!isEditingPassword ? (
                <p>
                  <strong>Password:</strong> *********{" "}
                  <button onClick={() => setIsEditingPassword(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Password:</strong>
                  </label>
                  <input
                    type="tel"
                    pattern="[0-9]{10}"
                    placeholder="Enter Password"
                    value={modify?.newpassword}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newpassword: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingPassword(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Approval */}
              {selectedUser?.role !== "bh" && (
                <>
                  {/* approval 1  */}
                  {["admin", "bh"].includes(userDetails?.role) ? (
                    !isEditingApproval1 ? (
                      <p>
                        <strong>Approval 1:</strong> {selectedUser.approval1}
                        <button onClick={() => setIsEditingApproval1(true)}>
                          <FaPencilAlt />
                        </button>
                      </p>
                    ) : (
                      <div className="input-block">
                        <label>
                          <strong>Approval 1:</strong>
                        </label>
                        <select
                          className="admin-portal-select"
                          value={modify?.newapproval1 || ""}
                          onChange={(e) =>
                            setmodify((prev) => ({
                              ...prev,
                              newapproval1: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Approval
                          </option>

                          {approval1?.map((approval, index) => (
                            <option key={index} value={approval?.id}>
                              {approval?.user_name}
                            </option>
                          ))}
                        </select>

                        <button onClick={() => setIsEditingApproval1(false)}>
                          &times;
                        </button>
                      </div>
                    )
                  ) : (
                    <p>
                      <strong>Approval 1:</strong>
                      {selectedUser.approval1}
                    </p>
                  )}
                  {/* approval 2  */}
                  {["admin", "bh"].includes(userDetails?.role) ? (
                    !isEditingApproval2 ? (
                      <p>
                        <strong>Approval 2:</strong> {selectedUser.approval2}
                        <button onClick={() => setIsEditingApproval2(true)}>
                          <FaPencilAlt />
                        </button>
                      </p>
                    ) : (
                      <div className="input-block">
                        <label>
                          <strong>Approval 2:</strong>
                        </label>
                        <select
                          className="admin-portal-select"
                          value={modify?.newapproval2 || ""}
                          onChange={(e) =>
                            setmodify((prev) => ({
                              ...prev,
                              newapproval2: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Department
                          </option>

                          {approval2?.map((approval, index) => (
                            <option key={index} value={approval?.id}>
                              {approval?.user_name}
                            </option>
                          ))}
                        </select>

                        <button onClick={() => setIsEditingApproval2(false)}>
                          &times;
                        </button>
                      </div>
                    )
                  ) : (
                    <p>
                      <strong>Approval 2:</strong>
                      {selectedUser.approval2}
                    </p>
                  )}
                </>
              )}

              {/* ACTIVE/INACTIVE  */}
              <Toggle
                label="Status"
                isOn={modify.isActive}
                onChange={(value) =>
                  setmodify((prev) => ({
                    ...prev,
                    isActive: value,
                  }))
                }
              />
            </div>
            <div className="sbtn1">
              <p>
                <button className="sbtn" onClick={handlemodify}>
                  Submit
                </button>
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UserDetailsTable;
